import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { LogService } from 'src/app/services/log.service';
import { Colors, Menu, MenuItem, Order, OrderItem } from '../../models';
import * as cfg from '../../../config.json';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-menu-order',
  templateUrl: './menu-order.component.html',
  styleUrls: ['./menu-order.component.scss']
})
export class MenuOrderComponent implements OnInit, AfterViewInit {

  @Input() menu$: BehaviorSubject<Menu>;
  @Input() order$: BehaviorSubject<Order>;
  @Input() appColors$: Subject<Colors>;
  @Input() usedByRestaurant: boolean = false;
  @Input() menuItemFilter$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  @ViewChildren('sectionLink') sectionLinks: QueryList<any>;
  @ViewChildren('section') sections: QueryList<any>;
  @ViewChild('stickyMenu', { read: ElementRef }) menuElement: ElementRef; // {read: ElementRef} used because referenced Element is an Angular child component as states in https://github.com/angular/components/issues/3922
  sticky: boolean = false;
  menuPosition: any;
  displayNoResultsMessage = 0;
  publicImageURL = cfg.default['imageUploading']['bucketPublicURL'];
  menuItemImgExt = cfg.default['imageUploading']['imageExt'];
  restID = '';
  displayFullImg = false;
  fullSizeImg = '';
  appColors = cfg.default['defaultAppColors'];
  
  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private log: LogService,
    private route: ActivatedRoute,
    private http: HttpClient
    ) { }

  ngOnInit(): void {
    this.restID = this.route.snapshot.paramMap.get('restId');
    this.appColors$.subscribe((colors) => {
      console.log(colors);
      // this.renderer.setStyle('h2', 'color', 'blue');
      this.appColors = colors;
    });
  }

  ngAfterViewInit() {
    // this.log.log(this.menuElement.nativeElement);
    this.menuPosition = this.menuElement.nativeElement.offsetTop;
    // this.sectionLink.changes.subscribe(() => {
    //   this.sectionLink.forEach(el => {
    //     this.log.log(el);
    //   })  
    // })
    // this.log.log(this.sectionLink);
    // this.sectionLink.forEach(el => {
    //   this.log.log(el);
    // })
    this.menuItemFilter$.subscribe((el) => {
       this.displayNoResultsMessage = (!el.some( row => row.includes(true)) && el.length);
    })
  }      

  @HostListener('window:scroll')
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll > this.menuPosition) {
      this.sticky = true;
    } else {
      this.sticky = false;
    }

    this.sectionLinks.forEach(link => {
      let section = this.sections.find(s => s.nativeElement.id === link.nativeElement.dataset.section);
      // this.log.log(section.nativeElement.offsetTop+section.nativeElement.offsetHeight);

      if (
        section.nativeElement.offsetTop - 50 <= windowScroll &&
        section.nativeElement.offsetTop + section.nativeElement.offsetHeight - 50 > windowScroll
      ) {
        // this.log.log(section.nativeElement.offsetTop+section.nativeElement.offsetHeight);
        // this.log.log(windowScroll);
        // this.log.log(link.nativeElement.getBoundingClientRect().left);
        console.log(link.nativeElement.getBoundingClientRect().left);

        if (link.nativeElement.getBoundingClientRect().left < 10) {
          link.nativeElement.scrollIntoView();
        }
        link.nativeElement.classList.add("current");
      } else {
        link.nativeElement.classList.remove("current");
      }
    });

  }

  addItem(item, variant = null) {
    // this.log.log(this.order$.value.value())
    const temp: Order = this.order$.value;
    const idx = temp.items.findIndex((i: OrderItem) => i.ref === item._id && (variant ? i.variant.idx === variant.idx : true));
    idx >= 0 ? temp.items[idx].quant++ : temp.items.push(new OrderItem(item, variant));
    this.order$.next(temp);
    // this.log.log(item._id);
    // this.log.log(temp);
    // this.log.log(this.order$.value.items);
    // this.log.log(this.menu$);
    // this.displayQuantity(item._id);

  }

  removeItem(itemID, variant = null) {
    const temp: Order = this.order$.value;
    const idx = temp.items.findIndex((i: OrderItem) => i.ref === itemID && (variant ? i.variant.idx === variant.idx : true));

    if (this.order$.value.items[idx].quant === 1) {
      temp.items.splice(idx, 1);
    } else {
      temp.items[idx].quant--;
    }
    this.order$.next(temp);
  }

  priorityToggle(e: MatCheckboxChange, item: MenuItem, variantObj: { name: string, idx: number } | null = null) {
    // this.log.log(e)
    // this.log.log(item)
    // this.log.log(variantObj)
    
    const editedItemIdx = this.findItemIdxInOrder(item,variantObj);
    const temp: Order = this.order$.value

    temp.items[editedItemIdx].priority = e.checked ? 10 : 0;
    this.order$.next(temp)
  }

  checkPriority(item:MenuItem, variantObj: { name: string, idx: number } | null = null) {
    return this.order$.value.items[this.findItemIdxInOrder(item,variantObj)].priority
  }

  findItemIdxInOrder(item:MenuItem, variantObj: { name: string, idx: number } | null = null) {    
    return this.order$.value.items.findIndex((i: OrderItem) => i.ref === item._id && (variantObj ? i.variant.idx === variantObj.idx : true))
  }

  displayQuantity(itemID, variant = null) {
    // this.log.log(this.order$.value);
    if (this.order$.value.items.find((i: OrderItem) => i.ref === itemID && (variant ? i.variant.idx === variant.idx : true)))
      return this.order$.value.items.find((i: OrderItem) => i.ref === itemID && (variant ? i.variant.idx === variant.idx : true)).quant;
  }

  scroll(id: string, event) {
    const menuNavBar = document.getElementById('menu-nav-bar');
    console.log(menuNavBar.offsetTop);

    const clickedElement = event.target;
    if (!clickedElement.classList.contains('current'))
      clickedElement.classList.add('current');

    var element = document.getElementById(id);

    if (this.sticky)
      var headerOffset = 50;
    else
      var headerOffset = 95;
    // var elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    var elementPosition = element.offsetTop;
    var offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }

  showImg(img) {
    this.fullSizeImg = this.publicImageURL + this.restID + '/' + img + this.menuItemImgExt;
    this.displayFullImg = true;
      // this.http.get(this.publicImageURL + this.restID + '/' + img + '.png').subscribe((img) => {
      //   console.log(img);
      // })
  }
}
